import routesModule from '../../../utilities/routes_module';
import { splitSlugAndId } from '../../../utilities/utilities';

/**
 * editReportPathFromTypeAndId: Creates edit funding report path from type and id
 *
 * @param {string} reportType - report type, such as 'funding_info' or 'grant'
 * @param {number} reportId - report id
 * @returns {string} - admin funding report url
 */
const editReportPathFromTypeAndId = (reportType, reportId) => {
  if (!reportType || !reportId) return '';

  switch (reportType) {
    // TO-DO Add type case per line below when migrated
    case 'funding_info':
      return `/admin/funding/${reportType}/${reportId}`;
    case 'shortlist':
      return routesModule[`edit_admin_procurement_${reportType}_path`](reportId);
    default:
      return routesModule[`edit_admin_development_data_${reportType}_path`](reportId);
  }
};

/**
 * editReportPathFromSlugAndId: Creates edit funding report path from slugAndId
 *
 * @param {string} reportSlugAndId - report slugAndId, such as 'funding_info-1234'
 * @returns {string} - admin funding report url
 */
const editReportPathFromSlugAndId = (reportSlugAndId) => {
  if (!reportSlugAndId) return;

  const reportId = splitSlugAndId(reportSlugAndId).id;
  const reportType = splitSlugAndId(reportSlugAndId).slug;

  return editReportPathFromTypeAndId(reportType, reportId);
};

export {
  editReportPathFromTypeAndId,
  editReportPathFromSlugAndId,
};
